<template>
  <div class="component-tablebox">
    <!-- <div v-if="isTabsRequired" class="d-flex justify-content-center m-3 ">
      <button
        type="button"
        class="btn mx-2  "
        :class="{
          'btn-success': isOfflineOrder === true,
          'btn-outline-success': isOfflineOrder === false
        }"
        @click="handleOfflineOrder"
      >
        Offline Orders</button
      >

      <button
        type="button"
        class="btn"
        :class="{
          'btn-success': isOfflineOrder === false,
          'btn-outline-success': isOfflineOrder === true
        }"
        @click="handleOnlineOrder"
      >
        Online Orders
      </button>
    </div> -->
    <b-row v-if="showToolbar" class="table-top-wrapper mb-2 mx-0">
      <b-col sm class="px-0">
        <b-form inline @submit.prevent>
          <b-input-group class="w-35 mb-2 box-shadow2">
            <b-form-input
              v-model="searchTerm"
              @keydown.native="search"
              placeholder="Search..."
              :class="{
                'bg-light text-dark box-shadow2': !isDarkMode,
                'bg-dark text-light placeholder-light box-shadow4': isDarkMode
              }"
            ></b-form-input>
            <template #append v-if="searchItems">
              <b-dropdown
                :text="selectedSearchVariable"
                class="box-shadow2"
                variant="success"
                :menu-class="isDarkMode ? 'bg-dark box-shadow4' : 'box-shadow2'"
              >
                <b-dropdown-item
                  v-for="item in searchItems"
                  :key="item"
                  @click="selectedSearchVariable = item"
                  :link-class="isDarkMode ? 'text-light bg-dark box-shadow4' : ''"
                  >{{ item }}</b-dropdown-item
                >
              </b-dropdown>
            </template>
          </b-input-group>
          <b-form-select
            v-model="filterSelected"
            :options="filterOptions"
            class="ml-2 w-35 mb-2"
            :class="{
              'box-shadow2 ml-2 mb-2  bg-light text-dark box-shadow2': !isDarkMode,
              'box-shadow2 ml-2 mb-2 bg-dark text-light': isDarkMode
            }"
            :link-class="isDarkMode ? 'text-light bg-dark' : ''"
          ></b-form-select>
          <b-form-select
            v-if="showOtherFilter"
            v-model="selectedSource"
            :options="sourceOptions"
            class="ml-2 w-35 mb-2"
            :class="{
              'box-shadow2 ml-2 mb-2  bg-light text-dark box-shadow2': !isDarkMode,
              'box-shadow2 ml-2 mb-2 bg-dark text-light': isDarkMode
            }"
          ></b-form-select>
        </b-form>
      </b-col>
      <b-col sm class="px-0">
        <b-form inline class="float-right">
          <b-form-datepicker
            id="start-datepicker"
            placeholder="Start Date"
            :min="minDate"
            :max="maxDate"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            v-model="startDateValue"
            class="ml-2 mb-2 box-shadow2"
            :class="{ 'dark-datepicker': isDarkMode }"
          ></b-form-datepicker>
          <b-form-datepicker
            id="end-datepicker"
            placeholder="End Date"
            :min="minDate"
            :max="maxDate"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            v-model="endDateValue"
            class="ml-2 mb-2 box-shadow2"
            :class="{ 'dark-datepicker': isDarkMode }"
          ></b-form-datepicker>
          <b-button variant="success" class="ml-2 mb-2 box-shadow2" @click="applyDate">Apply</b-button>
          <b-button variant="outline-secondary" class="ml-2 mb-2 box-shadow2" @click="clearDate">Clear</b-button>
        </b-form>
      </b-col>
    </b-row>
    <b-row class="table-bottom-wrapper mb-2 mx-0">
      <b-col :cols="12" class="px-0">
        <b-button v-if="showAdd" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickAdd">
          <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />{{ addText }}
        </b-button>
        <b-button v-if="showUpload" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickUpload">
          <font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />{{ uploadText }}
        </b-button>
        <b-button v-if="showDownload" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickDownload">
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadText }}
        </b-button>
        <b-button
          v-if="showDownloadOnline"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickDownloadOnline"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadTextOnline }}
        </b-button>
        <b-button v-if="showOtherDownload" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickList">
          <font-awesome-icon :icon="['fas', 'eye']" class="mr-1" />{{ listText }}
        </b-button>
        <b-button
          v-if="showDownloadMessageReport && !isReportsHidden"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickDownloadReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1 box-shadow2" />{{ downloadMessageReportText }}
        </b-button>
        <b-button
          v-if="showDownloadAptReport && !isReportsHidden"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickDownloadAptReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadAptText }}
        </b-button>
        <b-button
          v-if="showForthReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickFourthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ forthReportText }}
        </b-button>
        <b-button
          v-if="showFifthReport && !isReportsHidden"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickFifthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ fifthReportText }}
        </b-button>
        <b-button
          v-if="showDownloadProductReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickDownloadProductReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadProductReportText }}
        </b-button>
        <b-button
          v-if="showSixthReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          :disabled="disableSixthReport"
          @click="clickSixthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ sixthReportText }}
        </b-button>
        <b-button
          v-if="showChallanWiseReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          :disabled="disableSixthReport"
          @click="clickChallanWiseReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ challanWiseReportText }}
        </b-button>
        <b-button
          v-if="showSeventhReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickSeventhReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ seventhReportText }}
        </b-button>
        <b-button
          v-if="showEighthReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickEighthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ eighthReportText }}
        </b-button>
        <span v-if="downloading" class="spinner spinner-black"></span>
      </b-col>
    </b-row>
    <div class="table-top-wrapper">
      <div v-if="totalCount" class="row-total-count">
        <span>Total Count:</span>
        {{ totalCount }}
      </div>
    </div>
    <div v-if="loading" class="table-row table-row-empty">
      <div class="table-column table-column-full text-center">
        <span class="spinner spinner-black"></span>
      </div>
    </div>
    <div class="table-container">
      <div class="table-row table-row-header">
        <div
          v-for="(column, index) in columns"
          :key="column.id"
          :class="{
            ...column.class,
            'table-column': !isDarkMode,
            'table-column-dark': isDarkMode,
            'table-column-first': index === 0,
            'table-column-last-odd': columns.length === index + 1 && (columns.length - 1) % 2 === 1
          }"
          :style="columnStyle(column)"
        >
          {{ column.headerText }}
        </div>
      </div>

      <div class="table-row" v-for="row in rows" :key="row.id">
        <div
          v-for="(column, index) in columns"
          :key="column.id"
          class="table-column"
          :class="{
            ...column.class,
            dark: isDarkMode,
            'table-column-first': index === 0,
            'table-column-last-odd': columns.length === index + 1 && (columns.length - 1) % 2 === 1,
            'table-isPrinted': row.isPrinted === true
          }"
          :style="columnStyle(column)"
        >
          <slot v-if="column.slotKey" :name="column.slotKey" v-bind:row="row"></slot>
          <div v-if="column.htmlKey" v-html="row[column.htmlKey]"></div>
          <div v-if="column.urlKey"
            ><a :href="row[column.urlKey]" target="_blank">{{ row[column.urlKey] }}</a></div
          >
          <span v-if="column.textKey" class="span-text">{{ row[column.textKey] }}</span>
          <div v-if="column.type === 'functions'" class="text-center">
            <b-button-group size="sm">
              <b-button
                class="mb-1"
                v-if="column.functions.ack && row.source !== 'BULK_CSV_UPLOAD' && !row.isAcknowledged"
                size="sm"
                variant="success"
                @click="clickAcknowledge(row)"
              >
                <font-awesome-icon :icon="['fas', 'sms']" class="mr-1" />Acknowledge
              </b-button>
            </b-button-group>
            <b-button-group size="sm">
              <b-button
                v-if="column.functions.addOrder"
                class="box-shadow2"
                size="sm"
                variant="primary"
                @click="clickAddOrder(row)"
              >
                <font-awesome-icon :icon="['fas', 'plus']" class="mr-1 box-shadow2" />Add Order
              </b-button>
              <b-button v-if="column.functions.edit" size="sm" variant="secondary" @click="clickEdit(row)">
                <font-awesome-icon :icon="['fas', 'edit']" class="mr-1" />View/Edit
              </b-button>
              <b-button v-if="column.functions.delete" size="sm" variant="warning" @click="clickDelete(row)">
                <font-awesome-icon :icon="['fas', 'trash-alt']" class="mr-1" />Delete
              </b-button>
              <b-button v-if="column.functions.print" size="sm" variant="info" @click="clickPrint(row)">
                <font-awesome-icon :icon="['fas', 'copy']" class="mr-1" />Print
              </b-button>
            </b-button-group>
          </div>
        </div>
      </div>
      <div v-if="!loading && rows.length === 0" class="table-row table-row-empty">
        <div class="table-column table-column-full text-center">{{ emptyText }}</div>
      </div>
    </div>
    <b-row class="table-bottom-wrapper mt-2 mx-0">
      <b-col :cols="8" class="px-0">
        <b-button v-if="showAdd" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickAdd">
          <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />{{ addText }}
        </b-button>
        <b-button v-if="showDownload" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickDownload">
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadText }}
        </b-button>

        <b-button
          v-if="showDownloadOnline"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickDownloadOnline"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadTextOnline }}
        </b-button>
        <b-button v-if="showOtherDownload" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickList">
          <font-awesome-icon :icon="['fas', 'eye']" class="mr-1" />{{ listText }}
        </b-button>
        <b-button v-if="showUpload" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickUpload">
          <font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />{{ uploadText }}
        </b-button>
        <b-button
          v-if="showDownloadMessageReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickDownloadReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ downloadMessageReportText }}
        </b-button>
        <b-button
          v-if="showForthReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickFourthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ forthReportText }}
        </b-button>
        <b-button v-if="showFifthReport" size="sm" variant="success" class="mr-2 box-shadow2" @click="clickFifthReport">
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ fifthReportText }}
        </b-button>
        <b-button
          v-if="showSixthReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          :disabled="disableSixthReport"
          @click="clickSixthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ sixthReportText }}
        </b-button>
        <b-button
          v-if="showChallanWiseReport"
          size="sm"
          variant="success"
          :disabled="disableSixthReport"
          class="mr-2 box-shadow2"
          @click="clickChallanWiseReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ challanWiseReportText }}
        </b-button>
        <b-button
          v-if="showSeventhReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickSeventhReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ seventhReportText }}
        </b-button>
        <b-button
          v-if="showEighthReport"
          size="sm"
          variant="success"
          class="mr-2 box-shadow2"
          @click="clickEighthReport"
        >
          <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />{{ eighthReportText }}
        </b-button>
      </b-col>
      <b-col :cols="4" class="px-0 text-right" v-if="showPagination">
        <b-pagination-nav
          v-if="rows.length"
          v-model="currentPage"
          :link-gen="linkGen"
          :number-of-pages="totalNumberOfPage"
          use-router
          no-page-detect
          :class="{ '': !isDarkMode, 'dark-nav': isDarkMode }"
          align="right"
        ></b-pagination-nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    columns: Array,
    rows: Array,
    pagination: Object,
    baseUrl: String,
    emptyText: String,
    showAdd: Boolean,
    showForthReport: Boolean,
    showSixthReport: Boolean,
    showChallanWiseReport: Boolean,
    disableSixthReport: Boolean,
    showFifthReport: Boolean,
    showSeventhReport: Boolean,
    showEighthReport: Boolean,
    showDownload: Boolean,
    showDownloadOnline: Boolean,

    showToolbar: Boolean,
    searchItems: Array,
    filterOptions: Array,
    showOtherFilter: Boolean,
    sourceOptions: Array,
    showDownloadMessageReport: Boolean,
    showDownloadAptReport: Boolean,
    showDownloadProductReport: Boolean,
    showUpload: Boolean,
    downloadText: String,
    downloadTextOnline: String,

    showOtherDownload: Boolean,
    listText: String,
    uploadText: String,
    downloadMessageReportText: String,
    downloadAptText: String,
    downloadProductReportText: String,
    addText: String,
    forthReportText: String,
    sixthReportText: String,
    challanWiseReportText: String,
    fifthReportText: String,
    seventhReportText: String,
    eighthReportText: String,
    loading: Boolean,
    downloading: Boolean,
    showPagination: Boolean,
    isTabsRequired: Boolean,
    isOfflineOrder: Boolean
  },
  name: 'TableBox',
  data() {
    return {
      isOnlineData: false,
      filterSelected: null,
      selectedSource: null,
      startDateValue: moment().format('YYYY-MM-DD'),
      endDateValue: moment().format('YYYY-MM-DD'),
      searchTerm: null,
      isReportsHidden: false,
      minDate: moment().subtract('60', 'days').format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD'),
      selectedSearchVariable: this.searchItems && this.searchItems[0]
    };
  },
  mounted() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'filter')) {
      this.filterSelected = this.$route.query.filter;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'db')) {
      this.selectedSource = this.$route.query.db;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'search')) {
      this.searchTerm = this.$route.query.search;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'searchkey')) {
      this.selectedSearchVariable = this.$route.query.searchkey;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
      this.startDateValue = this.$route.query.startdate;
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'enddate')) {
      this.endDateValue = this.$route.query.enddate;
    }
  },
  watch: {
    filterSelected(newValue, oldValue) {
      if (newValue !== oldValue && this.$route.query.filter !== newValue) {
        if (!newValue) {
          const query = { ...this.$route.query };
          delete query.filter;
          this.$router.push({ query });
        } else {
          this.$router.push({ query: { ...this.$route.query, filter: newValue } });
        }
      }
    },
    selectedSource(newValue, oldValue) {
      if (newValue !== oldValue && this.$route.query.source !== newValue) {
        if (!newValue) {
          const query = { ...this.$route.query };
          delete query.db;
          delete query.startdate;
          delete query.enddate;
          this.startDateValue = moment().format('YYYY-MM-DD');
          this.endDateValue = moment().format('YYYY-MM-DD');
          this.minDate = moment().subtract(60, 'days').format('YYYY-MM-DD');
          this.maxDate = moment().format('YYYY-MM-DD');
          this.isReportsHidden = false;
          this.$router.push({ query });
        } else {
          const yearMonth = newValue.replace('-orders', '');

          this.isReportsHidden = true;
          const startOfMonth = moment(yearMonth, 'YYYY-MM').startOf('month');
          const endOfMonth = moment(yearMonth, 'YYYY-MM').endOf('month');

          this.minDate = startOfMonth.format('YYYY-MM-DD');
          this.maxDate = endOfMonth.format('YYYY-MM-DD');

          this.startDateValue = startOfMonth.format('YYYY-MM-DD');
          this.endDateValue = endOfMonth.format('YYYY-MM-DD');

          this.$router.push({
            query: {
              ...this.$route.query,
              db: newValue,
              startdate: this.startDateValue,
              enddate: this.endDateValue
            }
          });
        }
      }
    },
    searchTerm(newValue) {
      if (newValue === '' && Object.prototype.hasOwnProperty.call(this.$route.query, 'search')) {
        const query = { ...this.$route.query };
        delete query.search;
        this.$router.push({ query });
      }
    }
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    currentPage() {
      if (this.pagination.page) {
        return this.pagination.page;
      }
      return 1;
    },
    totalNumberOfPage() {
      if (this.pagination) {
        if (this.pagination.total_rows && this.pagination.page_size) {
          return Math.ceil(this.pagination.total_rows / this.pagination.page_size);
        }
      }
      return 0;
    },
    totalCount() {
      if (this.pagination) {
        return this.pagination.total_rows;
      }
      return 0;
    }
  },
  methods: {
    handleOfflineOrder() {
      if (!this.isOfflineOrder) {
        this.$router.push('/order');
        this.$emit('fetch-offline', {});
      }
    },
    handleOnlineOrder() {
      if (this.isOfflineOrder) {
        this.$router.push('/online-order-list');
        this.$emit('fetch-online', {});
      }
    },
    search(event) {
      if (event.key === 'Enter') {
        if (this.searchTerm) {
          if (this.$route.query.searchTerm !== this.searchTerm) {
            if (this.selectedSearchVariable) {
              this.$router.push({
                query: { ...this.$route.query, search: this.searchTerm, searchkey: this.selectedSearchVariable }
              });
            } else {
              this.$router.push({ query: { ...this.$route.query, search: this.searchTerm } });
            }
          }
        } else {
          const query = { ...this.$route.query };
          delete query.filter;
          this.$router.push({ query });
        }
      }
    },
    applyDate() {
      if (this.startDateValue) {
        this.$router.push({
          query: {
            ...this.$route.query,
            startdate: moment(this.startDateValue).format('YYYY-MM-DD')
          }
        });
      }
      if (this.endDateValue) {
        this.$router.push({
          query: {
            ...this.$route.query,
            enddate: moment(this.endDateValue).format('YYYY-MM-DD')
          }
        });
      }
    },
    clearDate() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        const query = { ...this.$route.query };
        delete query.startdate;
        delete query.enddate;
        this.$router.push({ query });
      }
      this.startDateValue = null;
      this.endDateValue = null;
    },
    columnStyle(column) {
      return { width: column.width };
    },
    linkGen(pageNum) {
      return { path: this.baseUrl, query: { ...this.$route.query, page: pageNum } };
    },
    clickAddOrder(row) {
      this.$emit('add-order', { row });
    },
    clickAdd() {
      this.$emit('add', {});
    },
    clickFourthReport() {
      this.$emit('fourth-report', {});
    },
    clickSixthReport() {
      this.$emit('sixth-report', {});
    },
    clickChallanWiseReport() {
      this.$emit('challan-wise-report', {});
    },
    clickFifthReport() {
      this.$emit('fifth-report', {});
    },
    clickSeventhReport() {
      this.$emit('seventh-report', {});
    },
    clickEighthReport() {
      this.$emit('eighth-report', {});
    },
    clickDownload() {
      this.$emit('download', {});
    },
    clickDownloadOnline() {
      this.$emit('download-online', {});
    },
    clickList() {
      this.$emit('list', {});
    },
    clickDownloadReport() {
      this.$emit('download-message-report', {});
    },
    clickDownloadAptReport() {
      this.$emit('apt-report', {});
    },
    clickDownloadProductReport() {
      this.$emit('download-product-report', {});
    },
    clickUpload() {
      this.$emit('show-upload', {});
    },
    clickEdit(row) {
      this.$emit('edit', { row });
    },
    clickDelete(row) {
      this.$emit('delete', { row });
    },
    clickPrint(row) {
      this.$emit('print', { row });
    },
    clickAcknowledge(row) {
      this.$emit('acknowledge', { row });
    },
    ifCallCenterExecutive() {
      const newUser = this.user.roles.map(role => role.name);
      const CallCenter = newUser.filter(role => role.includes('CALL_CENTER_EXECUTIVE'));
      if (CallCenter.length > 0) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.component-tablebox {
  font-size: 0.9rem;
}

.table-top-wrapper {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: left;
}

.table-isPrinted {
  background: #f5c9a9 !important;
  color: #2e2d2d;
}

.table-container {
  display: block;
  width: 100%;
}

.row-total-count {
  margin-bottom: 0.5rem;
}

.row-total-count span {
  font-weight: bold;
}

.table-row {
  display: flex;
  flex-flow: row wrap;
  border-left: solid 1px #d9d9d9;
  transition: 0.5s;
  margin-left: 0;
  margin-right: 0;
}

.table-row:first-of-type {
  border-top: solid 1px #d9d9d9;
  border-left: solid 1px #d9d9d9;
  border-bottom: solid 2px #d9d9d9;
}

.table-column {
  padding: 0.5em 0.5em;
  border-right: solid 1px #d9d9d9;
  border-bottom: solid 1px #d9d9d9;
  word-wrap: break-word;
}

.table-columns {
  display: flex;
  flex-flow: column wrap;
  width: 75%;
  padding: 0;
}

.table-columns .table-column {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 0;
  border: 0;
  border-bottom: solid 1px #d9d9d9;
}

.table-columns .table-column:hover {
  background: #f5f5f5;
  transition: 500ms;
}

.table-row:first-of-type .table-column {
  background: #fff;
  color: #000;
  border-color: #d9d9d9;
  font-weight: bold;
}

.table-row:nth-child(odd) .table-column {
  background: #f4f2f1;
}

/* .table-row:hover {
  background: #f5f5f5;
  transition: 500ms;
} */

.table-row:nth-child(odd) .dark {
  background: var(--primary-color);
}

.table-column-full {
  width: 100%;
}

.table-column-rowspan {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
}

.flex-cell {
  text-align: center;
  padding: 0.5em 0.5em;
  border-right: solid 1px #d9d9d9;
}

@media all and (max-width: 767px) {
  .table-row {
    border-bottom: solid 2px #d9d9d9;
    border-right: solid 1px #d9d9d9;
  }

  .table-row .table-column {
    width: 50% !important;
    border: 0;
    text-align: left !important;
    /* background: #fff; */
  }

  .table-row .table-column.table-column-first {
    border-bottom: solid 1px #d9d9d9;
    width: 100% !important;
  }

  .table-row .table-column.table-column-last-odd {
    width: 100% !important;
  }
}

@media all and (max-width: 430px) {
  .table-column {
    width: 100%;
  }

  .column .table-column {
    border-bottom: solid 1px;
  }

  .table-column.table-column-first {
    width: 100%;
    border-bottom: solid 1px #d9d9d9;
  }

  .table-row .table-column {
    width: 100% !important;
    border-bottom: 0;
    text-align: left !important;
  }

  .table-row .table-column:last-of-type {
    border-bottom: solid 1px #d9d9d9;
  }

  .table-columns {
    width: 100%;
  }

  .table-columns.table-column {
    border-bottom: solid 1px #d9d9d9;
  }

  .flex-cell {
    width: 100%;
  }
}
</style>
